import { Modal } from "antd";
import { EMatModalProps } from "../EMatModal/EMatModal";
import "./ErrorModal";

const ErrorModal = (props: EMatModalProps) => {
  return <Modal {...props}>{props.children}</Modal>;
};

export default ErrorModal;
